import { HttpService } from "./HttpService";
import { APIHOSTLINTAS } from '../config'

export const masterTypesAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listMasterTypes: object[] = [];

        const res = await HttpService.get(`inbound/master-types-all`, null, headers);
        const result: object[] = [];
        // console.log(res);

        if (res.status === 200 && res.data) {
            res.data.message.masterTypes.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.code} - ${item.name}`
                }

                result.push(data);
                data = {};
            });
            listMasterTypes = [{ id: "", code: "", codeName: "Select" }, ...result];
        }

        resolve(listMasterTypes);
    } catch (e) {
        console.log('error at get request projectsByOrganization with error: ', e);
        reject(e);
    }
});

export const warehouseAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listWarehouses: object[] = [];

        const res = await HttpService.get(`inbound/warehouses`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.warehouseCode} - ${item.warehouseName}`
                }

                result.push(data);
                data = {};
            });
            listWarehouses = [{ warehouseId: "", warehouseCode: "Select", codeName: "Select" }, ...result];
        }

        resolve(listWarehouses);
    } catch (e) {
        console.log('error at get request warehouseAll with error: ', e);
        reject(e);
    }
});

export const warehouseByOwner = (ownerId: string, headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listWarehouses: object[] = [];

        const res = await HttpService.get(`inbound/warehouses/${ownerId}/ownerId`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.warehouseCode} - ${item.warehouseName}`
                }

                result.push(data);
                data = {};
            });
            listWarehouses = [{ warehouseId: "", warehouseCode: "Select", codeName: "Select" }, ...result];
        }

        resolve(listWarehouses);
    } catch (e) {
        console.log('error at get request warehouseAll with error: ', e);
        reject(e);
    }
});

export const ownerWarehouseAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listWarehouses: object[] = [];

        const res = await HttpService.get(`inbound/owners`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.ownerCode} - ${item.description}`
                }

                result.push(data);
                data = {};
            });
            listWarehouses = [{ ownerId: "", ownerCode: "Select", codeName: "Select" }, ...result];
        }

        resolve(listWarehouses);
    } catch (e) {
        console.log('error at get request ownerWarehouseAll with error: ', e);
        reject(e);
    }
});

export const customerAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listCustomer: object[] = [];

        const res = await HttpService.get(`inbound/customers`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.customerCode} - ${item.customerName}`
                }

                result.push(data);
                data = {};
            });
            listCustomer = [{ customerId: "", customerCode: "Select", codeName: "Select" }, ...result];
        }

        resolve(listCustomer);
    } catch (e) {
        console.log('error at get request customerAll with error: ', e);
        reject(e);
    }
});
export const customsdocumentAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listcustomsdocument: object[] = [];

        const res = await HttpService.get(`inbound/customsdocuments`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.customsCode} - ${item.description}`
                }

                result.push(data);
                data = {};
            });
            listcustomsdocument = [{ customsDocumentId: "", customsCode: "Select", codeName: "Select" }, ...result];
        }

        resolve(listcustomsdocument);
    } catch (e) {
        console.log('error at get request customsdocumentAll with error: ', e);
        reject(e);
    }
});

export const supplierAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listSupplier: object[] = [];

        const res = await HttpService.get(`inbound/suppliers`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.supplierCode} - ${item.supplierName}`
                }

                result.push(data);
                data = {};
            });
            listSupplier = [{ supplierId: "", supplierCode: "Select", codeName: "Select" }, ...result];
        }

        resolve(listSupplier);
    } catch (e) {
        console.log('error at get request supplierAll with error: ', e);
        reject(e);
    }
});

export const currencyAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listCurrency: object[] = [];

        const res = await HttpService.get(`inbound/currencies`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.currencyCode} - ${item.description}`
                }

                result.push(data);
                data = {};
            });
            listCurrency = [{ currencyId: "", currencyCode: "Select", codeName: "Select" }, ...result];
        }

        resolve(listCurrency);
    } catch (e) {
        console.log('error at get request currencyAll with error: ', e);
        reject(e);
    }
});

export const skuProductAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listSkuProduct: object[] = [];

        const res = await HttpService.get(`inbound/skuproducts`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.productCode} - ${item.description}`
                }

                result.push(data);
                data = {};
            });
            listSkuProduct = [{ productId: "", productCode: "Select", codeName: "Select" }, ...result];
        }

        resolve(listSkuProduct);
    } catch (e) {
        console.log('error at get request supplierAll with error: ', e);
        reject(e);
    }
});

export const skuProductGroupAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listSkuProductGroup: object[] = [];

        const res = await HttpService.get(`inbound/skuproductgroups`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.productGroupCode} - ${item.description}`
                }

                result.push(data);
                data = {};
            });
            listSkuProductGroup = [{ productGroupId: "", productGroupCode: "Select", codeName: "Select" }, ...result];
        }

        resolve(listSkuProductGroup);
    } catch (e) {
        console.log('error at get request skuProductGroupAll with error: ', e);
        reject(e);
    }
});

export const packageTypeAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listPackageType: object[] = [];

        const res = await HttpService.get(`inbound/packagetypes`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.packageTypeCode} - ${item.description}`
                }

                result.push(data);
                data = {};
            });
            listPackageType = [{ packageTypeId: "", packageTypeCode: "Select", codeName: "Select" }, ...result];
        }

        resolve(listPackageType);
    } catch (e) {
        console.log('error at get request skuProductGroupAll with error: ', e);
        reject(e);
    }
});

export const uomAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listUom: object[] = [];

        const res = await HttpService.get(`inbound/uoms`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.uomCode} - ${item.description}`
                }

                result.push(data);
                data = {};
            });
            listUom = [{ uomId: "", uomCode: "", codeName: "Select" }, ...result];
        }

        resolve(listUom);
    } catch (e) {
        console.log('error at get request skuProductGroupAll with error: ', e);
        reject(e);
    }
});

export const locationAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listLocation: object[] = [];

        const res = await HttpService.get(`inbound/locations`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.locationName} - ${item.locationName}`
                }

                result.push(data);
                data = {};
            });
            listLocation = [{ locationId: "", locationName: "Select", codeName: "Select" }, ...result];
        }

        resolve(listLocation);
    } catch (e) {
        console.log('error at get request locationAll with error: ', e);
        reject(e);
    }
});

export const locationForPutaway = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listLocation: object[] = [];

        const res = await HttpService.get(`inbound/location/putaways`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.locationName} - ${item.locationName}`
                }

                result.push(data);
                data = {};
            });
            listLocation = [{ locationId: "", locationName: "Select", codeName: "Select" }, ...result];
        }

        resolve(listLocation);
    } catch (e) {
        console.log('error at get request locationForPutaway with error: ', e);
        reject(e);
    }
});

export const goodsStatusAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let goodsStatus: object[] = [];

        const res = await HttpService.get(`inbound/goodsstatuses`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.goodsStatusCode} - ${item.description}`
                }

                result.push(data);
                data = {};
            });
            goodsStatus = [{ goodsStatusId: "", goodsStatusCode: "", codeName: "Select" }, ...result];
        }

        resolve(goodsStatus);
    } catch (e) {
        console.log('error at get request goodsStatusAll with error: ', e);
        reject(e);
    }
});

export const receivingStatusAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let receivingStatus: object[] = [];

        const res = await HttpService.get(`inbound/receivingstatuses`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.statusCode} - ${item.description}`
                }

                result.push(data);
                data = {};
            });
            receivingStatus = [{ statusId: "", statusCode: "", codeName: "Select" }, ...result];
        }

        resolve(receivingStatus);
    } catch (e) {
        console.log('error at get request receivingStatusAll with error: ', e);
        reject(e);
    }
});

export const containerTypeAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let containerTypes: object[] = [];

        const res = await HttpService.get(`inbound/containertypes`, null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                let data = {
                    ...item,
                    codeName: `${item.containertypeCode} - ${item.containertypeName}`
                }

                result.push(data);
                data = {};
            });
            containerTypes = [{ containertypeId: "", containertypeCode: "", codeName: "Select" }, ...result];
        }

        resolve(containerTypes);
    } catch (e) {
        console.log('error at get request containerTypeAll with error: ', e);
        reject(e);
    }
});


export const previousAjuNumberReceivingAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listPreviousAjuNumber: object[] = [];

        const res = await HttpService.get('inbound/receiving/previousajunumber', null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                if (item.previousAjuNumber) {
                    result.push(item);
                }
            });
            listPreviousAjuNumber = [...result];
        }
        resolve(listPreviousAjuNumber);
    } catch (e) {
        console.log('Error get previousajunumber: ', e);
        reject(e);
    }
});

export const previousNopenReceivingAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listPreviousNopen: object[] = [];

        const res = await HttpService.get('inbound/receiving/previousnopen', null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                if (item.previousNopen) {
                    result.push(item);
                }
            });
            listPreviousNopen = [...result];
        }
        resolve(listPreviousNopen);
    } catch (e) {
        console.log('Error get previousNopen: ', e);
        reject(e);
    }
});

export const previousAjuNumberInventoryAll = (headers: any) => new Promise(async (resolve, reject) => {
    try {
        let listPreviousAjuNumber: object[] = [];

        const res = await HttpService.get('inventory/inventory/previousajunumbers', null, headers);
        const result: object[] = [];

        if (res.status === 200 && res.data) {
            res.data.message.forEach((item: any) => {
                if (item.previousAjuNumber) {
                    result.push(item);
                }
            });
            listPreviousAjuNumber = [...result];
        }
        resolve(listPreviousAjuNumber);
    } catch (e) {
        console.log('Error get previousajunumber: ', e);
        reject(e);
    }
});

export const LocationList = (resAuth: any) => new Promise(async (resolve, reject) => {
    try {
        const res = await HttpService.post(
            'authentication/users',
            {
                "Action": "READ_LOCATION"
            },
            resAuth
        );

        const newLocations = [
            ...res.data.message.Locations,
        ];
        newLocations.forEach((item) => item.LocationID = item.ID);
        resolve(newLocations);
    } catch (e) {
        console.log(e);
        reject(e);
    }
})

export const CompanyCodeList = (resAuth: any) => new Promise(async (resolve, reject) => {
    try {
        const contracts = [
            {
                CompanyCode: 'Select',
            }
        ];
        const res = await HttpService.post(
            `${APIHOSTLINTAS}/auth/contracts`,
            {
                "Action": "GET_ALL_COMPANY_CODE"
            },
            resAuth
        );
        const newContracts = [
            ...contracts,
            ...res.data.message.Contracts ? res.data.message.Contracts : [],
        ];
        resolve(newContracts);
    } catch (e) {
        console.log(e);
        reject(e);
    }
})

export const CompanyCodeBPList = (resAuth: any) => new Promise(async (resolve, reject) => {
    try {
        let newBusinessPartners: object[] = [];

        const res = await HttpService.post(
            `${APIHOSTLINTAS}/auth/businesspartners`,
            {
                "Action": "GET_ALL_COMPANY_CODE"
            },
            resAuth
        );

        if (res.data.message.BusinessPartners) {
            newBusinessPartners = [
                ...res.data.message.BusinessPartners,
            ];
        }

        resolve(newBusinessPartners);
    } catch (e) {
        console.log(e);
        reject(e);
    }
})


export const UserList = (UserTypeID: number, resAuth: any) => new Promise(async (resolve, reject) => {
    try {
        const locations = [
            {
                ID: '',
                Name: 'Select',
                Email: 'Select',
                Address: '',
                Phone: '',
                Company: '',
                UserLocations: [],
                IsActive: '',
                CreatedBy: '',
                CreatedAt: '',
                ModifiedBy: '',
                UpdatedAt: '',
            }
        ];
        const res = await HttpService.post(
            `authentication/users`,
            {
                "Action": "READ_USER_BY_USER_TYPE",
                'User': { 'UserTypeID': UserTypeID },
            },
            resAuth
        );

        const newLocations = [
            ...locations,
            ...res.data.message.Users,
        ];
        newLocations.forEach((item) => item.UserID = item.ID);
        
        resolve(newLocations);
    } catch (e) {
        console.log(e);
        reject(e);
    }
})

export const UserCompanyByEmailUserTypeList = (UserTypeID: number, resAuth: any) => new Promise(async (resolve, reject) => {
    try {
        const locations = [
            {
                ID: '',
                Name: 'Select',
                Email: 'Select',
                Address: '',
                Phone: '',
                Company: '',
                UserLocations: [],
                IsActive: '',
                CreatedBy: '',
                CreatedAt: '',
                ModifiedBy: '',
                UpdatedAt: '',
            }
        ];
        const res = await HttpService.post(
            `authentication/users`,
            {
                "Action": "READ_USER_COMPANY_BY_USER_TYPE",
                'User': { 'UserTypeID': UserTypeID,  },
            },
            resAuth
        );

        

        const result = res.data.message.Users || []
        const newLocations = [
            ...locations,
            ...result,
        ];
        newLocations.forEach((item) => item.UserID = item.ID);
        resolve(newLocations);
    } catch (e) {
        console.log(e);
        reject(e);
    }
})